<template>
  <v-card flat rounded="lg">
    <v-card-title class="subtitle-1 font-weight-bold">Cliente</v-card-title>
    <v-card-text>
      <btn-selecionar-cliente />
      <template v-if="novopedido.cliente">
        <v-list-item class="rounded-lg grey lighten-4 mt-2">
          <v-list-item-content>
            <v-list-item-subtitle>Cliente selecionado</v-list-item-subtitle>
            <v-list-item-title class="mt-2"
              >{{ novopedido.cliente.nome }} -
              {{ novopedido.cliente.matricula }}</v-list-item-title
            >
            <v-list-item-subtitle class="caption grey--text text--darken-1"
              >{{ novopedido.cliente.cidade }}/{{
                novopedido.cliente.uf
              }}</v-list-item-subtitle
            >
          </v-list-item-content>
          <v-list-item-action>
            <v-row>
              <v-col>
                <btn-editar-cliente :cliente="novopedido.cliente" />
                <btn-perfil-cliente :cliente="novopedido.cliente" />
              </v-col>
            </v-row>
          </v-list-item-action>
        </v-list-item>

        <card-mensagens-cliente
          v-if="novopedido.cliente.mensagens.length > 0"
          :cliente="novopedido.cliente"
          dense
        />
      </template>
    </v-card-text>
  </v-card>
</template>

<script>
import BtnPerfilCliente from "@/components/perfil-cliente/BtnPerfilCliente.vue";
import { mapState } from "vuex";
import BtnSelecionarCliente from "./botoes/BtnSelecionarCliente.vue";
import BtnEditarCliente from "@/components/clientes/BtnEditarCliente.vue";
import CardMensagensCliente from "@/components/clientes/CardMensagensCliente.vue";

export default {
  props: {},
  components: {
    BtnSelecionarCliente,
    BtnPerfilCliente,
    BtnEditarCliente,
    CardMensagensCliente,
  },
  computed: mapState("pedidos", ["novopedido"]),
};
</script>

<style>
.v-list-item__title,
.v-list-item__subtitle {
  white-space: unset !important;
}
</style>
